import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalService } from '../../../../shared/modules/bs-modal/services/modal.service';
import { DirectDebitService } from '../../services/direct-debit.service';
import { Subscription } from 'rxjs';
import { SuccessModal } from './success-popup/constant.modal';
import { ITransferOrderMaxAndForeignResponse } from '../../interfaces/ITransferOrderMaxAndForeignResponse.interface';
import { IContentResponse } from '../../interfaces/IContentResponse.interface';
import { GtmService } from '../../../../shared/cardholders-core/services/gtm.service';
import { Router } from '@angular/router';
import { UiHelperService } from '../../../../shared/cardholders-core/services/ui-helper.service';

@Component({
    selector: 'app-success',
    templateUrl: './success.component.html',
    styleUrls: ['./success.component.scss']
})
export class SuccessComponent implements OnInit, OnDestroy {
    subs: Subscription[] = [];
    res: ITransferOrderMaxAndForeignResponse;
    rc: number;
    contents: IContentResponse;
    isPartialSuccess: boolean;
    successCount: number;
    total: number;
    constructor(
        private directDebSrv: DirectDebitService,
        private modalSrv: ModalService,
        private uiHelper: UiHelperService,
        private gtmService: GtmService,
        private router: Router
    ) {
    }
    ngOnDestroy(): void {
        this.subs.map((s) => s.unsubscribe());
    }
    get bgImg(): string {
        return `url(${
            this.uiHelper.IsMobile()
                ? this.contents.success.headerMobileImage
                : this.contents.success.headerDesktopImage
        }) 0% 0%  no-repeat`;
    }
    showStandingOrderData(): void {
        this.gtmService.pushDirectDebit('part success', 'click details');
        SuccessModal.options.initialState = {
            transactions: this.res.standingOrderData,
            total: this.total,
            successCount: this.successCount,
            subTitle: this.contents.success.subListHok,
            subTitleMobile: this.contents.success.subListHokMobile
        } as Object;
        this.subs.push(
            this.modalSrv.openModal(SuccessModal).subscribe((x) => {
                if (x) {
                }
            })
        );
    }
    ngOnInit(): void {
        this.res = this.directDebSrv.transferOrderMaxAndForeignResponse;
        this.rc = this.directDebSrv.transferOrderMaxAndForeignRc;
        this.subs.push(this.directDebSrv.contents$.subscribe((contents) => (this.contents = contents)));
        this.total = this.res.standingOrderData.length;
        this.successCount = this.res.standingOrderData.filter(
            (x) => x.rowReturnCode === 0 || x.rowReturnCode === 11
        ).length;
        this.isPartialSuccess =
            this.rc === 18 ||
            (this.rc === 20 && this.res.standingOrderData.some((x) => x.rowReturnCode !== 0 && x.rowReturnCode !== 11));
        if (this.isPartialSuccess) {
            this.gtmService.pushDirectDebitWorkFlow('part success', 'load', '3');
            this.gtmService.pushDirectDebit('part success', `${this.successCount} from ${this.total}`);
            this.gtmService.pushDirectDebit('part success', this.res.crmCaseId);
        } else {
            this.gtmService.pushDirectDebitWorkFlow('full success', 'load', '3');
            this.gtmService.pushDirectDebit('full success', this.res.crmCaseId);
        }
    }
    goBackHome(): void {
        if (this.isPartialSuccess) {
            this.gtmService.pushDirectDebit('part success', 'click back home');
        } else {
            this.gtmService.pushDirectDebit('full success', 'click back home');
        }
        this.router.navigate(['/']);
    }
}
